import { render, staticRenderFns } from "./ChartTable.vue?vue&type=template&id=ed9d670c&scoped=true&"
import script from "./ChartTable.vue?vue&type=script&lang=js&"
export * from "./ChartTable.vue?vue&type=script&lang=js&"
import style0 from "./ChartTable.vue?vue&type=style&index=0&id=ed9d670c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9d670c",
  null
  
)

export default component.exports